import { createRoot } from 'react-dom/client';
import { App } from './app';

const appElement = document.getElementById('app');

createRoot(appElement!).render(
  <div>
    <App />
  </div>,
);
